<template>
  <v-card outlined class="pa-4 petmed-pets">
    <span class="pw-section d-block mb-3">Mascotas atendidas</span>

    <div v-if="loading" class="state-msg py-10 text-center">
      <v-progress-circular indeterminate size="24" width="2" color="primary" />
    </div>
    <div v-else-if="error" class="state-msg py-10 text-center">
      <v-icon small color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
      No se pudo cargar el detalle de mascotas.
    </div>
    <div v-else-if="species.length === 0" class="state-msg py-10 text-center">
      Sin mascotas atendidas en el período
    </div>
    <template v-else>
      <div class="d-flex flex-wrap species-legend mb-3">
        <div v-for="(s, i) in species" :key="s.key">
          <span class="pw-label d-flex align-center">
            <span class="legend-dot" :class="`legend-dot--${i % 2 === 0 ? 'strong' : 'soft'}`" />
            {{ s.label }}
          </span>
          <div class="pw-kpi">{{ s.percentage.toFixed(1) }}%</div>
          <span class="pw-pct">{{ s.attendances }} atenciones</span>
        </div>
      </div>
      <div class="species-bar" role="img" :aria-label="speciesAria">
        <div
          v-for="(s, i) in species"
          :key="s.key"
          class="species-segment"
          :class="`species-segment--${i % 2 === 0 ? 'strong' : 'soft'}`"
          :style="{ width: `${s.percentage}%` }"
        />
      </div>
    </template>
  </v-card>
</template>

<script>
import { speciesShare } from '@/utils/petmed-metrics.utils';

export default {
  name: 'PetmedPetsBreakdown',

  props: {
    // insights.bySpecies del contrato
    bySpecies: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },

  computed: {
    species() {
      return speciesShare(this.bySpecies);
    },
    speciesAria() {
      return this.species.map((s) => `${s.label} ${s.percentage.toFixed(1)}%`).join(', ');
    },
  },
};
</script>

<style scoped>
.state-msg {
  font-size: 13px;
  color: var(--pw-text-muted);
}
.species-bar {
  display: flex;
  height: 14px;
  border-radius: var(--pw-radius-chip);
  overflow: hidden;
  background: var(--pw-divider);
}
.species-segment {
  height: 100%;
}
.species-segment + .species-segment {
  border-left: 2px solid var(--pw-surface);
}
.species-segment--strong,
.legend-dot--strong {
  background: var(--pw-primary);
}
.species-segment--soft,
.legend-dot--soft {
  background: var(--pw-link);
}
.species-legend {
  gap: 32px;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
}
</style>
